import React from "react";
import { Link } from "react-router-dom";

const VideoSection = () => {
  return (
    <div>
      <style>
        {`
          .image-column {
            background-size: cover;
            background-position: center;
            
            }

          .image img, .overlay-link img {
            width: 100%;
            height: 100%;
          }

          
          @media (max-width: 1022px) {
            .image-column {
              background-size: contain;
            }

            .image img, .overlay-link img {
              object-fit: contain;
            }
          }
          @media (max-width: 768px) {
            .image-column {
              background-size: contain;
            }

            .image img, .overlay-link img {
              object-fit: contain;
            }
          }
        `}
      </style>
      <section className="fluid-section-one">
        <div className="outer-container clearfix">
          <div className="content-column">
            <div className="content-box">
              <h2>Crafting Timeless Elegance</h2>
              <div className="text">
                At VAMA JEWELS, we specialize in creating exquisite jewelry
                that stands the test of time. From intricate designs to
                certified authenticity, each piece is a masterpiece crafted with
                care and precision.
              </div>
              <ul className="list-style-one">
              <li><i className="fa-solid fa-circle-right"/> Exclusive Diamond Collections</li>
              <li><i className="fa-solid fa-circle-right"/> Certified Gold Jewelry</li>
              <li><i className="fa-solid fa-circle-right"/> Custom Designs Tailored to You</li>
              <li><i className="fa-solid fa-circle-right"/> Elegant Engagement Rings</li>

                <Link to="/contact" style={{color:"black",marginTop:"20px" }}><u>Talk to a Jewelry Expert</u></Link>
              </ul>
            </div>
          </div>
          <div
            className="image-column"
            
          >
            
              <Link to="#" className="overlay-link" >
                <img 
                  src="images/Showcase.jpg"
                  style={{ objectFit: "cover" , border:"4px solid gray" , borderRadius:"20px"}}
                  alt="Jewelry Showcase"
                />
              </Link>
            </div>
          </div>
      </section>
    </div>
  );
};

export default VideoSection;
